import { UseMutationOptions, useMutation } from "react-query";
import { http } from "./http";

export enum ChatRole {
    Assistant = 'assistant',
    User = 'user',
    System = 'system',
}

export type ChatLine = {
    role: ChatRole,
    content: string
}

export type AiChatRequest = {
    messages: ChatLine[],
    jsonMode?: boolean
}

export function useAiChatMutation(ops?: UseMutationOptions<any, any, any, any>) {
    return useMutation({
        ...ops,
        mutationFn: (request: AiChatRequest) => http(`/api/ai/chat`, {
            method: "POST",
            body: request
        })
    });
}
